import { useMemo } from "react";
import { CroppingPatternReportModel } from "@agroyaar/sdk";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import Description from "@/shared/components/report-template/presentation/components/common/Description";
import ColumnChart, {
  ColumnChartData,
} from "@/shared/components/charts/ColumnChart";
import { mapIndexToChartData } from "@/features/reports/presentation/components/cropping-pattern/utils/make-chart-data";

interface ClimaticAdaptabilityIndexProps {
  croppingPatternReports: CroppingPatternReportModel[];
}

const ClimaticAdaptabilityIndex = ({
  croppingPatternReports,
}: ClimaticAdaptabilityIndexProps) => {
  const chartData: ColumnChartData[] = useMemo(
    () =>
      mapIndexToChartData(croppingPatternReports, "climaticAdaptabilityIndex"),
    [croppingPatternReports]
  );

  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={5}>
      <div className="w-full flex flex-col gap-6">
        <Title>شاخص الگوی کشت برای پارامترهای مختلف در محصولات منتخب</Title>
        <Description>
          برای محصولات منتخب، شاخص الگوی کشت پارامترهای کلیدی مانند{" "}
          <span className="leading-[28px] text-[16px] !font-[B-Nazanin] font-bold">
            اقلیم ، خاک و آب
          </span>{" "}
          بررسی شده است. نتایج سازگاری هر پارامتر در نمودارهای زیر مشخص شده است.
        </Description>
      </div>

      <div className="w-full flex flex-col justify-center items-start gap-3 my-12">
        <Title>سازگاری اقلیمی</Title>
        <div className="w-full flex flex-col justify-center items-center gap-3 my-8">
          <ColumnChart
            data={chartData}
            yAxisTitle="شاخص الگو کشت"
            decimalNumber={2}
          />
          <Title>سازگاری اقلیمی محصولات منتخب</Title>
        </div>
      </div>
    </ReportTemplate>
  );
};

export default ClimaticAdaptabilityIndex;
